import { useTranslations } from 'contexts/Translation'
import { PageWrapper, Row, Col } from '@qonsoll/react-design'
import { useParams, useHistory } from 'react-router-dom'
import { useBrandbookInitialValues } from 'domains/Brandbook/hooks'
import { Spin } from '@qonsoll/react-design'

const BrandbookEdit = (props) => {
  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const history = useHistory()
  const params = useParams()
  const { brandbookId } = params
  const [initialValues, loading] = useBrandbookInitialValues(brandbookId)

  // [COMPONENT_STATE_HOOKS]

  // [COMPUTED_PROPERTIES]
  const headingProps = {
    title: t('Brandbook edit'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  // [HANDLERS]
  const handleBackButtonClick = () => history.goBack()

  return (
    <PageWrapper headingProps={headingProps}>
      <Row noGutters>
        {loading ? (
          <Col>
            <Spin />
          </Col>
        ) : (
          <Col cw={[12, 12, 10, 8, 7]}>
            <>BrandbookAdvancedForm</>
          </Col>
        )}
      </Row>
    </PageWrapper>
  )
}

export default BrandbookEdit
